module.exports = __webpack_public_path__ + "img/Logo-2022-Motivate.232a9493.png";